import type { FC } from 'react'

import { TableWithFilter, useStepControllerMethods } from '../../components'
import type { OnChangeVspOffsetFunc, OnSetFilterFormFunc, RowWellVsp } from '../../types'

type StepChooseBaseWellProps = {
  onChangeVspOffset: OnChangeVspOffsetFunc
}

export const StepChooseBaseWell: FC<StepChooseBaseWellProps> = ({ onChangeVspOffset }) => {
  const { addNextStep, setContextToActiveStep } = useStepControllerMethods()

  const handleRowClick = (row: RowWellVsp) => {
    addNextStep(row.wellName, 'wellVspSettings', row.id)
  }

  const saveContext: OnSetFilterFormFunc = form => {
    setContextToActiveStep('chooseBaseWell', form)
  }

  return (
    <TableWithFilter
      hasNextStep={true}
      saveContext={saveContext}
      onRowClick={handleRowClick}
      onChangeVspOffset={onChangeVspOffset}
    />
  )
}
